/* Farm game pixel sprite generator — 24x24 tiles, 24x32 character, limited palette.
   Exposes window.SpriteLib = { PAL, all(), toCanvas(grid, scale, mk) } */
(function () {
  const PAL = {
    _: null,
    K:  '#171420', // outline / darkest
    D:  '#3c3550', // deep shadow
    b1: '#55402f', // soil dark / boots
    b2: '#7d5a3c', // soil mid
    b3: '#a8804f', // wood / soil light
    b4: '#d3aa72', // straw / wood light
    g1: '#1e5138', // green darkest
    g2: '#367a43', // green dark
    g3: '#62ab52', // green mid
    g4: '#9ed167', // green light
    y1: '#e0b23c', // gold
    y2: '#f4e07a', // pale yellow
    r1: '#b8332c', // red
    r2: '#e2603c', // red light
    p1: '#6b3a8f', // purple
    p2: '#a05fc0', // purple light
    n1: '#6e6a78', // stone dark
    n2: '#9a96a4', // stone mid
    n3: '#c4c0c8', // stone light
    w:  '#f4ece0', // cream
    s:  '#e0a077', // skin
    s2: '#b87954', // skin shade
    c1: '#2a5fa8', // denim / water dark
    c2: '#57a8d8'  // water light
  };

  /* ---------- grid toolbox ---------- */
  const G = (w, h) => ({ w, h, d: new Array(w * h).fill('_') });
  const px = (g, x, y, c) => { if (!c || x < 0 || y < 0 || x >= g.w || y >= g.h) return; g.d[y * g.w + x] = c; };
  const get = (g, x, y) => (x < 0 || y < 0 || x >= g.w || y >= g.h) ? '_' : g.d[y * g.w + x];
  const rect = (g, x, y, w, h, c) => { for (let j = 0; j < h; j++) for (let i = 0; i < w; i++) px(g, x + i, y + j, c); };
  const disc = (g, cx, cy, rx, ry, c) => {
    for (let y = Math.floor(cy - ry); y <= Math.ceil(cy + ry); y++)
      for (let x = Math.floor(cx - rx); x <= Math.ceil(cx + rx); x++) {
        const dx = (x - cx) / rx, dy = (y - cy) / ry;
        if (dx * dx + dy * dy <= 1.08) px(g, x, y, c);
      }
  };
  function hash(x, y, s) {
    let n = (x * 374761393 + y * 668265263 + (s || 0) * 982451653) | 0;
    n = (n ^ (n >> 13)) * 1274126177; n = n ^ (n >> 16);
    return ((n >>> 0) % 1024) / 1024;
  }
  function outline(g, c) {
    const out = g.d.slice();
    for (let y = 0; y < g.h; y++) for (let x = 0; x < g.w; x++) {
      if (get(g, x, y) !== '_') continue;
      if (get(g, x - 1, y) !== '_' || get(g, x + 1, y) !== '_' || get(g, x, y - 1) !== '_' || get(g, x, y + 1) !== '_')
        out[y * g.w + x] = c;
    }
    g.d = out; return g;
  }
  function flipX(g) {
    const n = G(g.w, g.h);
    for (let y = 0; y < g.h; y++) for (let x = 0; x < g.w; x++) n.d[y * g.w + (g.w - 1 - x)] = g.d[y * g.w + x];
    return n;
  }
  function recolor(g, map) {
    for (let i = 0; i < g.d.length; i++) if (map[g.d[i]]) g.d[i] = map[g.d[i]];
    return g;
  }
  function stamp(dst, src, ox, oy) {
    for (let y = 0; y < src.h; y++) for (let x = 0; x < src.w; x++) {
      const c = src.d[y * src.w + x]; if (c !== '_') px(dst, ox + x, oy + y, c);
    }
    return dst;
  }

  /* ---------- terrain (all patterns are functions of x,y so they tile) ---------- */
  const T = 24;

  function grass(seed) {
    const g = G(T, T);
    // patchy two-octave value noise (wraps, so the tile stays seamless)
    const patch = (x, y) => 0.6 * hash(Math.floor(x / 4), Math.floor(y / 4), seed) + 0.4 * hash(Math.floor(x / 8), Math.floor(y / 8), seed + 5);
    for (let y = 0; y < T; y++) for (let x = 0; x < T; x++) {
      const p = patch(x, y), fine = hash(x, y, seed + 2);
      let c = 'g2';
      if (p > 0.62) c = fine > 0.55 ? 'g3' : 'g2';
      else if (p < 0.34) c = fine > 0.7 ? 'g1' : 'g2';
      px(g, x, y, c);
    }
    // sparse blade tufts
    for (let i = 0; i < 5; i++) {
      const bx = Math.floor(hash(i, 3, seed + 9) * T), by = Math.floor(hash(i, 11, seed + 4) * T);
      px(g, bx, by, 'g4'); px(g, bx, (by + 1) % T, 'g3'); px(g, (bx + 1) % T, (by + 1) % T, 'g1');
    }
    return g;
  }

  function tilled(wet) {
    const g = G(T, T);
    const base = wet ? 'b1' : 'b2', dark = wet ? 'K' : 'b1', light = wet ? 'b2' : 'b3';
    for (let y = 0; y < T; y++) for (let x = 0; x < T; x++) {
      const r = y % 6, h = hash(x, y, wet ? 21 : 20);
      let c = base;
      if (r === 0) c = dark; else if (r === 1) c = light; else if (h > 0.88) c = light; else if (h < 0.12) c = dark;
      px(g, x, y, c);
    }
    if (wet) for (let i = 0; i < 5; i++) px(g, Math.floor(hash(i, 7, 33) * T), (Math.floor(hash(i, 2, 44) * 4) * 6) + 2, 'D');
    return g;
  }

  function dirtPath() {
    const g = G(T, T);
    for (let y = 0; y < T; y++) for (let x = 0; x < T; x++) {
      const h = hash(x, y, 5);
      px(g, x, y, h > 0.9 ? 'b4' : h > 0.75 ? 'b2' : h < 0.08 ? 'b1' : 'b3');
    }
    return g;
  }

  function stonePath() {
    const g = G(T, T);
    rect(g, 0, 0, T, T, 'n2');
    for (let y = 0; y < T; y++) for (let x = 0; x < T; x++) if (hash(x, y, 8) > 0.88) px(g, x, y, 'n3');
    // 2x2 flagstones with mortar joints
    for (let y = 0; y < T; y++) for (let x = 0; x < T; x++) {
      const gx = x % 12, gy = y % 12;
      if (gx === 0 || gy === 0) px(g, x, y, 'n1');
      if (gx === 1 || gy === 1) px(g, x, y, 'n3');
    }
    return g;
  }

  function woodFloor() {
    const g = G(T, T);
    for (let y = 0; y < T; y++) for (let x = 0; x < T; x++) {
      const r = y % 8, h = hash(x, y, 12);
      let c = h > 0.9 ? 'b4' : 'b3';
      if (r === 0) c = 'b1'; else if (r === 1) c = 'b4';
      const plank = Math.floor(y / 8);
      if ((x + plank * 9) % 24 === 0 && r > 0) c = 'b1';
      px(g, x, y, c);
    }
    return g;
  }

  function water() {
    const g = G(T, T);
    rect(g, 0, 0, T, T, 'c1');
    for (let y = 0; y < T; y++) for (let x = 0; x < T; x++) if (hash(x, y, 15) > 0.9) px(g, x, y, 'c2');
    for (const [wx, wy] of [[3, 5], [14, 9], [7, 17], [18, 20]]) {
      rect(g, wx, wy, 4, 1, 'c2'); px(g, wx + 4, wy + 1, 'c2'); px(g, wx - 1, wy + 1, 'c2');
    }
    return g;
  }

  // ragged edge amount for a given direction: how deep the overlay reaches
  function edgeMask(dir, x, y) {
    const jag = (v, s) => 3 + Math.floor(hash(v, s, 77) * 3); // 3..5 px deep
    const n = y < jag(x, 1), s = y >= T - jag(x, 2), w = x < jag(y, 3), e = x >= T - jag(y, 4);
    switch (dir) {
      case 'N': return n; case 'S': return s; case 'W': return w; case 'E': return e;
      case 'NW': return n || w; case 'NE': return n || e; case 'SW': return s || w; case 'SE': return s || e;
      case 'IN_NW': return n && w; case 'IN_NE': return n && e; case 'IN_SW': return s && w; case 'IN_SE': return s && e;
    }
    return false;
  }

  function transition(baseFn, overFn, dir) {
    const base = baseFn(), over = overFn(), g = G(T, T);
    for (let y = 0; y < T; y++) for (let x = 0; x < T; x++)
      px(g, x, y, edgeMask(dir, x, y) ? over.d[y * T + x] : base.d[y * T + x]);
    return g;
  }

  function fence(kind) {
    const g = G(T, T);
    const post = (x) => { rect(g, x, 6, 4, 14, 'b3'); rect(g, x, 6, 4, 1, 'b4'); rect(g, x + 3, 7, 1, 13, 'b1'); };
    const railH = (y) => { rect(g, 0, y, T, 3, 'b3'); rect(g, 0, y, T, 1, 'b4'); rect(g, 0, y + 2, T, 1, 'b1'); };
    if (kind === 'post') post(10);
    if (kind === 'h') { railH(10); railH(15); }
    if (kind === 'post_h') { railH(10); railH(15); post(10); }
    if (kind === 'v') { rect(g, 10, 0, 4, T, 'b3'); rect(g, 10, 0, 1, T, 'b4'); rect(g, 13, 0, 1, T, 'b1'); }
    if (kind === 'corner') { railH(10); railH(15); rect(g, 10, 10, 4, 14, 'b3'); rect(g, 13, 10, 1, 14, 'b1'); post(10); }
    outline(g, 'K');
    return g;
  }

  /* ---------- crops ---------- */
  function soilBed(g, wet) {
    for (let x = 0; x < T; x++) {
      const top = 20 + (hash(x, 1, 60) > 0.7 ? -1 : 0);
      for (let y = top; y < T; y++) px(g, x, y, y === top ? (wet ? 'b2' : 'b3') : (hash(x, y, 61) > 0.8 ? 'b2' : 'b1'));
    }
  }

  function stem(g, x, y0, y1, c, cd) {
    rect(g, x, y0, 2, y1 - y0 + 1, c); rect(g, x + 1, y0, 1, y1 - y0 + 1, cd || 'g1');
  }

  function leafPair(g, y, span, c, cd) {
    for (let i = 1; i <= span; i++) {
      px(g, 10 - i, y - Math.floor(i / 2), c); px(g, 13 + i, y - Math.floor(i / 2), c);
      px(g, 10 - i, y + 1 - Math.floor(i / 2), cd); px(g, 13 + i, y + 1 - Math.floor(i / 2), cd);
    }
  }

  const CROPS = [
    { id: 'wheat', name: 'Wheat', kind: 'grain', a: 'y1', b: 'y2' },
    { id: 'corn', name: 'Corn', kind: 'cob', a: 'y2', b: 'y1' },
    { id: 'sunflower', name: 'Sunflower', kind: 'flower', a: 'y1', b: 'y2' },
    { id: 'tomato', name: 'Tomato', kind: 'bush', a: 'r1', b: 'r2', n: 3 },
    { id: 'strawberry', name: 'Strawberry', kind: 'low', a: 'r1', b: 'r2', n: 3 },
    { id: 'eggplant', name: 'Eggplant', kind: 'bush', a: 'p1', b: 'p2', n: 2, oval: true },
    { id: 'potato', name: 'Potato', kind: 'root', a: 'b3', b: 'b4' },
    { id: 'carrot', name: 'Carrot', kind: 'root', a: 'r2', b: 'y1' },
    { id: 'onion', name: 'Onion', kind: 'root', a: 'w', b: 'p2' },
    { id: 'cabbage', name: 'Cabbage', kind: 'head', a: 'g3', b: 'g4' },
    { id: 'pumpkin', name: 'Pumpkin', kind: 'head', a: 'y1', b: 'r2' },
    { id: 'grapes', name: 'Grapes', kind: 'vine', a: 'p1', b: 'p2' }
  ];
  const STAGES = ['seed', 'sprout', 'young', 'ripe', 'withered'];

  function cropSprite(cfg, stageIdx) {
    const g = G(T, T);
    const stg = STAGES[stageIdx];
    soilBed(g, stg !== 'seed' && stg !== 'withered');

    if (stg === 'seed') {
      rect(g, 9, 18, 6, 2, 'b2'); rect(g, 10, 17, 4, 1, 'b3');
      px(g, 11, 17, 'b4'); px(g, 13, 18, 'b4');
      return g;
    }
    if (stg === 'sprout') {
      stem(g, 11, 16, 20, 'g3', 'g2');
      px(g, 9, 16, 'g4'); px(g, 10, 15, 'g4'); px(g, 14, 16, 'g4'); px(g, 13, 15, 'g4');
      px(g, 9, 17, 'g3'); px(g, 14, 17, 'g3');
      return g;
    }
    if (stg === 'withered') {
      // dead remains, silhouette follows the crop's habit
      const tall = cfg.kind === 'grain' || cfg.kind === 'cob' || cfg.kind === 'flower';
      const low = cfg.kind === 'low' || cfg.kind === 'root' || cfg.kind === 'head';
      if (cfg.kind === 'vine') {
        rect(g, 5, 8, 2, 12, 'b2'); rect(g, 6, 8, 1, 12, 'b1'); rect(g, 5, 8, 14, 2, 'b2'); rect(g, 5, 9, 14, 1, 'b1');
        for (const [x, y] of [[9, 12], [12, 13], [15, 12], [17, 14]]) { px(g, x, y, 'b3'); px(g, x, y + 1, 'b1'); px(g, x + 1, y + 2, 'b2'); }
        return g;
      }
      if (tall) {
        for (const sx of [8, 12, 16]) {
          const top = 9 + (sx === 12 ? -1 : 1);
          rect(g, sx, top, 1, 20 - top, 'b2'); px(g, sx + 1, top + 1, 'b1');
          px(g, sx + (sx > 12 ? 1 : -1), top, 'b3'); px(g, sx + (sx > 12 ? 2 : -2), top + 1, 'b1');
        }
        px(g, 12, 8, 'y1');
        return g;
      }
      const top = low ? 16 : 13;
      rect(g, 11, top, 2, 20 - top, 'b2'); px(g, 12, top, 'b1');
      for (const [x, y] of [[9, top + 1], [8, top + 2], [14, top + 1], [15, top + 2], [9, top + 4], [15, top + 4]]) { px(g, x, y, 'b3'); px(g, x, y + 1, 'b1'); }
      px(g, 10, top - 1, 'y1'); px(g, 13, top - 1, 'b3');
      return g;
    }

    const ripe = stg === 'ripe';
    switch (cfg.kind) {
      case 'grain': {
        const heads = [[7, 8], [11, 5], [16, 9]];
        for (const [x, top] of heads) {
          stem(g, x, top + 3, 20, ripe ? 'y1' : 'g3', ripe ? 'b3' : 'g2');
          if (ripe) {
            for (let j = 0; j < 4; j++) { rect(g, x - 1, top + j, 4, 1, j % 2 ? cfg.a : cfg.b); }
            px(g, x, top - 1, 'y2');
          } else { rect(g, x - 1, top + 1, 4, 2, 'g4'); }
        }
        break;
      }
      case 'cob': {
        stem(g, 11, ripe ? 4 : 9, 20, 'g2', 'g1');
        const lv = ripe ? [7, 11, 15] : [12, 16];
        for (const y of lv) { leafPair(g, y, ripe ? 5 : 3, 'g3', 'g2'); }
        if (ripe) { disc(g, 15, 12, 2, 4, cfg.a); rect(g, 14, 9, 2, 3, 'g4'); disc(g, 14, 12, 1, 3, cfg.b); px(g, 11, 3, 'g4'); }
        break;
      }
      case 'flower': {
        stem(g, 11, ripe ? 6 : 11, 20, 'g2', 'g1');
        leafPair(g, ripe ? 14 : 16, 4, 'g3', 'g2');
        if (ripe) { disc(g, 12, 6, 5, 4, cfg.a); disc(g, 12, 6, 3, 2.5, 'b2'); disc(g, 12, 6, 1.5, 1.2, 'b1'); }
        else { disc(g, 12, 10, 2, 2, 'g4'); }
        break;
      }
      case 'bush': {
        stem(g, 11, 11, 20, 'g2', 'g1');
        leafPair(g, 13, 4, 'g3', 'g2'); leafPair(g, 17, 3, 'g3', 'g2');
        disc(g, 12, 11, 4, 3, 'g3'); disc(g, 12, 10, 3, 2, 'g4');
        if (ripe) {
          const spots = cfg.oval ? [[9, 15], [15, 14]] : [[8, 15], [16, 14], [12, 17]];
          spots.forEach(([x, y]) => {
            if (cfg.oval) { disc(g, x, y, 2, 3, cfg.a); disc(g, x, y - 1, 1, 1.5, cfg.b); px(g, x, y - 3, 'g2'); }
            else { disc(g, x, y, 2, 2, cfg.a); px(g, x - 1, y - 1, cfg.b); px(g, x, y - 2, 'g2'); }
          });
        }
        break;
      }
      case 'low': {
        disc(g, 12, 16, 6, 3.5, 'g2'); disc(g, 12, 15, 5, 2.5, 'g3');
        for (let i = 0; i < 6; i++) px(g, 7 + i * 2, 14 + (i % 2), 'g4');
        if (ripe) [[8, 18], [15, 18], [12, 19]].forEach(([x, y]) => {
          disc(g, x, y, 1.6, 1.8, cfg.a); px(g, x, y - 1, cfg.b); px(g, x, y - 2, 'g2'); px(g, x + 1, y, 'w');
        });
        break;
      }
      case 'root': {
        const tuft = ripe ? 4 : 3;
        for (let i = -tuft; i <= tuft; i++) {
          const h = 5 + Math.abs(i) - tuft + (ripe ? 5 : 2);
          rect(g, 12 + i, 19 - h, 1, h, i % 2 ? 'g2' : 'g3');
        }
        if (ripe) {
          if (cfg.id === 'carrot') { rect(g, 11, 19, 3, 2, cfg.a); px(g, 12, 21, cfg.a); }
          if (cfg.id === 'onion') { disc(g, 12, 20, 3, 2.5, cfg.a); disc(g, 11, 20, 1.5, 1.5, cfg.b); }
          if (cfg.id === 'potato') { disc(g, 9, 21, 2, 1.5, cfg.a); disc(g, 15, 21, 2, 1.5, cfg.b); }
        }
        break;
      }
      case 'head': {
        const big = ripe;
        if (big) {
          if (cfg.id === 'pumpkin') {
            disc(g, 12, 16, 7, 5, cfg.a); disc(g, 8, 16, 2.4, 4.6, cfg.b); disc(g, 16, 16, 2.4, 4.6, cfg.b);
            rect(g, 11, 10, 2, 2, 'g2'); px(g, 13, 10, 'g3');
          } else {
            disc(g, 12, 16, 7, 5, 'g2'); disc(g, 12, 15, 5, 3.5, cfg.a); disc(g, 11, 14, 2.5, 2, cfg.b);
            for (let i = 0; i < 4; i++) px(g, 6 + i * 4, 19 - (i % 2), 'g1');
          }
        } else {
          disc(g, 12, 17, 5, 3, 'g3'); disc(g, 12, 16, 3, 2, 'g4');
          for (let i = 0; i < 3; i++) px(g, 9 + i * 3, 13 + (i % 2), 'g2');
        }
        break;
      }
      case 'vine': {
        rect(g, 5, 8, 2, 12, 'b3'); rect(g, 6, 8, 1, 12, 'b1'); rect(g, 5, 8, 14, 2, 'b3'); rect(g, 5, 9, 14, 1, 'b1');
        for (let i = 0; i < 4; i++) { px(g, 8 + i * 3, 11, 'g2'); px(g, 9 + i * 3, 12, 'g3'); }
        leafPair(g, 13, 4, 'g3', 'g2');
        if (ripe) {
          for (let row = 0; row < 4; row++) for (let i = 0; i <= row; i++) {
            const x = 15 - row + i * 2, y = 12 + row * 2;
            disc(g, x, y, 1.2, 1.2, cfg.a); px(g, x - 1, y - 1, cfg.b);
          }
        }
        break;
      }
    }
    return g;
  }

  /* ---------- tools (standalone 24x24 items) ---------- */
  function tool(id) {
    const g = G(T, T);
    const handle = (x0, y0, x1, y1) => {
      const n = Math.max(Math.abs(x1 - x0), Math.abs(y1 - y0));
      for (let i = 0; i <= n; i++) {
        const x = Math.round(x0 + (x1 - x0) * i / n), y = Math.round(y0 + (y1 - y0) * i / n);
        px(g, x, y, 'b3'); px(g, x + 1, y, 'b2');
      }
    };
    if (id === 'hoe') { handle(5, 20, 16, 5); rect(g, 13, 3, 6, 2, 'n2'); rect(g, 13, 5, 3, 2, 'n1'); rect(g, 13, 3, 6, 1, 'n3'); }
    if (id === 'axe') { handle(6, 20, 15, 6); disc(g, 17, 6, 4, 4, 'n2'); rect(g, 13, 3, 3, 6, 'n1'); disc(g, 18, 6, 2.5, 3, 'n3'); }
    if (id === 'shears') {
      // open blades forming an X, pivot at centre, looped handles below
      for (let i = 0; i < 8; i++) { px(g, 11 - i, 11 - i, 'n3'); px(g, 12 - i, 11 - i, 'n2'); px(g, 12 + i, 11 - i, 'n2'); px(g, 13 + i, 11 - i, 'n3'); }
      rect(g, 11, 11, 3, 2, 'n1'); px(g, 12, 12, 'K');
      handle(11, 13, 8, 19); handle(13, 13, 16, 19);
      rect(g, 5, 18, 4, 2, 'b3'); rect(g, 15, 18, 4, 2, 'b3'); px(g, 5, 20, 'b2'); px(g, 18, 20, 'b2');
    }
    if (id === 'wateringcan') {
      rect(g, 6, 10, 10, 9, 'n2'); rect(g, 6, 10, 10, 1, 'n3'); rect(g, 14, 11, 2, 8, 'n1');
      rect(g, 16, 8, 3, 2, 'n2'); rect(g, 18, 6, 3, 3, 'n3'); // spout
      rect(g, 7, 6, 2, 5, 'n1'); rect(g, 7, 5, 6, 2, 'n2'); rect(g, 12, 6, 2, 4, 'n1'); // handle
      rect(g, 8, 14, 5, 2, 'c2');
    }
    if (id === 'seedbag') {
      disc(g, 12, 16, 7, 6, 'b4'); disc(g, 9, 15, 3, 3.5, 'w');
      rect(g, 9, 7, 6, 4, 'b3'); rect(g, 8, 9, 8, 2, 'b2');
      rect(g, 10, 5, 4, 2, 'b4'); px(g, 11, 4, 'y1'); px(g, 13, 5, 'y1');
      rect(g, 10, 15, 5, 1, 'b2'); rect(g, 11, 18, 3, 1, 'b3');
    }
    if (id === 'pickaxe') { handle(6, 20, 14, 8); rect(g, 8, 4, 12, 2, 'n2'); rect(g, 8, 4, 12, 1, 'n3'); px(g, 7, 6, 'n1'); px(g, 20, 6, 'n1'); rect(g, 13, 6, 3, 2, 'n1'); }
    if (id === 'scythe') { handle(6, 21, 12, 6); for (let i = 0; i < 12; i++) { px(g, 12 + i - Math.floor(i * 0.15), 5 - Math.round(i * 0.45), 'n3'); px(g, 12 + i - Math.floor(i * 0.15), 6 - Math.round(i * 0.45), 'n2'); } }
    if (id === 'fishingrod') {
      handle(4, 20, 9, 13); for (let i = 0; i < 11; i++) px(g, 9 + i, 13 - i, 'b3');
      rect(g, 7, 15, 3, 3, 'n2'); px(g, 20, 3, 'n3');
      for (let i = 0; i < 6; i++) px(g, 20 - i, 4 + i * 2, 'w');
      disc(g, 15, 17, 1.6, 1.6, 'r1'); px(g, 15, 16, 'w');
    }
    outline(g, 'K');
    return g;
  }

  /* ---------- character ---------- */
  const CH_W = 24, CH_H = 32;
  const HAT = 'b4', HAT2 = 'b3', HAIR = 'b1', SH = 'r1', SH2 = 'r2', OV = 'c1', OV2 = 'D', BT = 'b1';

  function heldTool(g, id, hx, hy, ang) {
    // ang: 'up' | 'fwd' | 'down' | 'side'
    const line = (x0, y0, x1, y1, c) => {
      const n = Math.max(Math.abs(x1 - x0), Math.abs(y1 - y0)) || 1;
      for (let i = 0; i <= n; i++) px(g, Math.round(x0 + (x1 - x0) * i / n), Math.round(y0 + (y1 - y0) * i / n), c);
    };
    let tx = hx, ty = hy;
    if (id === 'hoe' || id === 'axe' || id === 'shears' || id === 'pickaxe' || id === 'scythe') {
      if (ang === 'up') { line(hx, hy, hx + 3, hy - 10, 'b3'); line(hx + 1, hy, hx + 4, hy - 10, 'b2'); tx = hx + 3; ty = hy - 11; }
      if (ang === 'back') { line(hx, hy, hx - 8, hy - 8, 'b3'); line(hx, hy + 1, hx - 8, hy - 7, 'b2'); tx = hx - 9; ty = hy - 9; }
      if (ang === 'fwd') { line(hx, hy, hx + 9, hy - 3, 'b3'); line(hx, hy + 1, hx + 9, hy - 2, 'b2'); tx = hx + 10; ty = hy - 3; }
      if (ang === 'sweep') { line(hx, hy, hx + 10, hy + 2, 'b3'); line(hx, hy + 1, hx + 10, hy + 3, 'b2'); tx = hx + 11; ty = hy + 2; }
      if (ang === 'down') { line(hx, hy, hx + 6, hy + 6, 'b3'); line(hx + 1, hy, hx + 7, hy + 6, 'b2'); tx = hx + 7; ty = hy + 7; }
      if (id === 'hoe') { rect(g, tx - 1, ty, 4, 2, 'n2'); rect(g, tx - 1, ty, 4, 1, 'n3'); }
      if (id === 'axe') { rect(g, tx - 1, ty - 1, 3, 4, 'n2'); rect(g, tx, ty - 1, 2, 1, 'n3'); }
      if (id === 'pickaxe') { rect(g, tx - 3, ty, 7, 2, 'n2'); rect(g, tx - 3, ty, 7, 1, 'n3'); px(g, tx - 4, ty + 1, 'n1'); px(g, tx + 4, ty + 1, 'n1'); }
      if (id === 'scythe') { for (let i = 0; i < 7; i++) px(g, tx + i - 1, ty - Math.round(i * 0.7), 'n3'); for (let i = 0; i < 7; i++) px(g, tx + i - 1, ty + 1 - Math.round(i * 0.7), 'n2'); }
      if (id === 'shears') { rect(g, tx - 1, ty, 2, 3, 'n3'); rect(g, tx + 1, ty, 1, 3, 'n2'); }
    }
    if (id === 'wateringcan') {
      rect(g, hx - 1, hy, 6, 5, 'n2'); rect(g, hx - 1, hy, 6, 1, 'n3'); rect(g, hx + 4, hy + 1, 1, 4, 'n1');
      rect(g, hx + 5, hy + 1, 2, 1, 'n2'); rect(g, hx + 6, hy + 2, 2, 1, 'n3');
    }
    if (id === 'rod') {
      if (ang === 'back') { line(hx, hy, hx - 9, hy - 9, 'b3'); line(hx, hy + 1, hx - 9, hy - 8, 'b2'); }
      else if (ang === 'bent') { line(hx, hy, hx + 8, hy - 7, 'b3'); line(hx + 8, hy - 7, hx + 12, hy - 2, 'b3'); }
      else { line(hx, hy, hx + 11, hy - 9, 'b3'); line(hx + 1, hy, hx + 12, hy - 9, 'b2'); }
    }
    if (id === 'crate') {
      rect(g, hx - 3, hy - 4, 11, 7, 'b3'); rect(g, hx - 3, hy - 4, 11, 1, 'b4'); rect(g, hx - 3, hy + 2, 11, 1, 'b1');
      rect(g, hx + 1, hy - 3, 1, 5, 'b2'); rect(g, hx - 1, hy - 2, 2, 2, 'g3'); rect(g, hx + 4, hy - 3, 2, 2, 'r1');
    }
  }

  function farmer(o) {
    const dir = o.dir || 'down', pose = o.pose || 'idle', legs = o.legs == null ? 0 : o.legs;
    const bob = o.bob || 0, tool = o.tool || null, crouch = pose === 'harvest_low' ? 3 : 0;
    const g = G(CH_W, CH_H);
    const side = dir === 'left' || dir === 'right';
    const yb = bob + crouch;

    // legs
    // walk cycle: 0 contact, 1 left lifted+forward, 2 pass, 3 right lifted+forward
    const legStep = (which) => {
      if (pose !== 'walk') return { dy: 0, dx: 0 };
      if (legs === 1) return which === 'l' ? { dy: -2, dx: 1 } : { dy: 0, dx: -1 };
      if (legs === 3) return which === 'l' ? { dy: 0, dx: -1 } : { dy: -2, dx: 1 };
      return { dy: 0, dx: 0 };
    };
    const drawLeg = (x, st) => {
      const h = 5 + st.dy * -1 * 0; // constant length, foot lifts
      rect(g, x + st.dx, 22 + yb + st.dy, 3, 5, OV);
      rect(g, x + st.dx, 22 + yb + st.dy, 1, 5, OV2);
      rect(g, x + st.dx, 27 + yb + st.dy, 3, 2, BT);
      if (st.dy < 0) rect(g, x, 27 + yb, 3, 1, OV2); // shin filling the gap
      return h;
    };
    if (side) {
      drawLeg(dir === 'right' ? 9 : 12, legStep('l'));
      drawLeg(dir === 'right' ? 12 : 9, legStep('r'));
    } else { drawLeg(9, legStep('l')); drawLeg(13, legStep('r')); }

    // torso + overalls
    const tx = side ? 9 : 8, tw = side ? 7 : 8;
    rect(g, tx, 12 + yb, tw, 5, SH);
    rect(g, tx, 12 + yb, tw, 1, SH2);
    rect(g, tx, 17 + yb, tw, 5, OV);
    rect(g, tx, 17 + yb, tw, 1, OV2);
    rect(g, tx + 1, 13 + yb, 1, 4, OV); rect(g, tx + tw - 2, 13 + yb, 1, 4, OV);
    if (!side) px(g, 12, 19 + yb, 'y1');

    // head
    const hx = side ? 9 : 8, hw = side ? 7 : 8;
    rect(g, hx, 6 + yb, hw, 6, 's');
    rect(g, hx, 11 + yb, hw, 1, 's2');
    if (dir === 'up') { rect(g, hx, 6 + yb, hw, 5, HAIR); }
    else if (side) {
      rect(g, dir === 'right' ? hx : hx + hw - 2, 6 + yb, 2, 4, HAIR);
      px(g, dir === 'right' ? hx + 5 : hx + 1, 9 + yb, 'K');
      px(g, dir === 'right' ? hx + 6 : hx, 10 + yb, 's2');
    } else {
      rect(g, hx, 6 + yb, 1, 4, HAIR); rect(g, hx + hw - 1, 6 + yb, 1, 4, HAIR);
      rect(g, hx, 6 + yb, hw, 1, HAIR);
      px(g, hx + 2, 9 + yb, 'K'); px(g, hx + 5, 9 + yb, 'K');
      rect(g, hx + 3, 11 + yb, 2, 1, 's2');
    }
    // straw hat
    rect(g, 6, 5 + yb, 12, 1, HAT); rect(g, 5, 6 + yb, 14, 1, HAT2);
    rect(g, 9, 2 + yb, 6, 3, HAT); rect(g, 9, 2 + yb, 6, 1, 'w'); rect(g, 9, 4 + yb, 6, 1, HAT2);
    if (side) { rect(g, dir === 'right' ? 16 : 5, 5 + yb, 3, 1, HAT); }

    // arms + tool
    const armY = 13 + yb;
    const arm = (x, y, h) => { rect(g, x, y, 2, h, SH); rect(g, x, y + h, 2, 1, 's'); };
    let hand = null, ang = 'fwd';
    if (pose === 'idle' || pose === 'walk') {
      const sw = pose === 'walk' ? (legs === 1 ? 1 : legs === 3 ? -1 : 0) : 0;
      arm(tx - 2, armY + sw, 5 - Math.abs(sw)); arm(tx + tw, armY - sw, 5 - Math.abs(sw));
      hand = [tx + tw + 1, armY + 6 - sw]; ang = 'down';
    } else if (pose === 'windup') {
      arm(tx - 2, armY, 4); rect(g, tx + tw, armY - 3, 2, 5, SH); px(g, tx + tw, armY - 4, 's'); px(g, tx + tw + 1, armY - 4, 's');
      hand = [tx + tw + 1, armY - 4]; ang = 'up';
    } else if (pose === 'strike') {
      arm(tx - 2, armY + 1, 4); rect(g, tx + tw, armY + 2, 3, 2, SH); px(g, tx + tw + 3, armY + 3, 's');
      hand = [tx + tw + 3, armY + 4]; ang = 'down';
    } else if (pose === 'hold' || pose === 'water') {
      rect(g, tx - 2, armY, 2, 4, SH); rect(g, tx + tw, armY, 2, 4, SH);
      px(g, tx + tw, armY + 4, 's'); px(g, tx + tw + 1, armY + 4, 's');
      hand = [tx + tw + 1, armY + 4]; ang = 'fwd';
    } else if (pose === 'harvest_low') {
      rect(g, tx - 2, armY + 3, 2, 4, SH); rect(g, tx + tw, armY + 3, 2, 4, SH);
      px(g, tx + tw, armY + 7, 's');
      hand = [tx + tw, armY + 7]; ang = 'down';
    } else if (pose === 'carry') {
      rect(g, tx - 2, armY - 1, 2, 3, SH); rect(g, tx + tw, armY - 1, 2, 3, SH);
      hand = [12, armY - 1]; ang = 'fwd';
    } else if (pose === 'cast0') {
      rect(g, tx - 2, armY, 2, 4, SH);
      rect(g, tx + tw - 1, armY - 4, 2, 6, SH); px(g, tx + tw - 1, armY - 5, 's'); px(g, tx + tw, armY - 5, 's');
      hand = [tx + tw, armY - 5]; ang = 'back';
    } else if (pose === 'cast1') {
      rect(g, tx - 2, armY + 1, 2, 4, SH);
      rect(g, tx + tw, armY - 1, 3, 2, SH); px(g, tx + tw + 3, armY, 's');
      hand = [tx + tw + 3, armY + 1]; ang = 'fwd';
    } else if (pose === 'reel0' || pose === 'reel1') {
      const d = pose === 'reel1' ? 1 : 0;
      rect(g, tx - 2, armY + 1 + d, 2, 3, SH); rect(g, tx + tw, armY + 1 + d, 2, 3, SH);
      px(g, tx + tw + 1, armY + 4 + d, 's');
      hand = [tx + tw + 1, armY + 3 + d]; ang = 'bent';
    } else if (pose === 'eat0' || pose === 'eat1') {
      rect(g, tx - 2, armY, 2, 5, SH);
      rect(g, tx + tw - 1, armY - 2, 2, 4, SH); px(g, tx + tw - 1, armY - 3, 's');
      if (pose === 'eat0') { px(g, tx + tw - 1, armY - 4, 'r2'); px(g, tx + tw, armY - 4, 'r1'); }
      hand = null;
    }
    if (tool && hand) {
      if (o.sweep) ang = 'sweep';
      if (dir === 'up') {
        // facing away: tool sits behind the body
        const tg = G(CH_W, CH_H);
        if (tool === 'crate') heldTool(tg, 'crate', 8, armY - 1); else heldTool(tg, tool, hand[0], hand[1], ang);
        stamp(tg, g, 0, 0);
        g.d = tg.d;
      } else if (tool === 'crate') heldTool(g, 'crate', 8, armY - 1);
      else heldTool(g, tool, hand[0], hand[1], ang);
    }
    if (pose === 'water' && tool === 'wateringcan') {
      for (const [dx, dy] of [[9, 6], [10, 8], [11, 10], [8, 9]]) px(g, hand[0] + dx, hand[1] + dy, 'c2');
    }
    if (pose === 'harvest_low') { disc(g, hand[0] + 2, hand[1] + 2, 1.5, 1.5, 'r1'); px(g, hand[0] + 2, hand[1], 'g2'); }

    outline(g, 'K');
    return dir === 'left' ? flipX(g) : g;
  }

  // lying-down poses don't use the standing rig
  function farmerDown(kind) {
    const g = G(CH_W, CH_H);
    const y0 = 18;
    rect(g, 4, y0 + 2, 15, 6, SH); rect(g, 4, y0 + 2, 15, 1, SH2);
    rect(g, 4, y0 + 8, 13, 4, OV); rect(g, 4, y0 + 8, 13, 1, OV2);
    rect(g, 2, y0 + 10, 4, 2, BT); rect(g, 2, y0 + 6, 3, 2, 's');
    disc(g, 19, y0 + 5, 4, 4, 's'); rect(g, 17, y0 + 1, 6, 2, HAIR);
    if (kind === 'faint') {
      rect(g, 12, y0 - 4, 10, 2, HAT2); rect(g, 14, y0 - 7, 6, 3, HAT); rect(g, 14, y0 - 7, 6, 1, 'w');
      px(g, 18, y0 + 4, 'K'); px(g, 20, y0 + 4, 'K');
      rect(g, 6, y0 - 1, 3, 1, 'n3'); rect(g, 10, y0 - 2, 3, 1, 'n3');
    } else {
      rect(g, 15, y0 + 2, 9, 2, HAT2); rect(g, 17, y0 + 4, 6, 3, HAT); rect(g, 17, y0 + 4, 6, 1, 'w');
    }
    outline(g, 'K');
    return g;
  }

  const TIERS = {
    copper: { n1: 'b2', n2: 'b3', n3: 'b4' },
    steel: { n1: 'n1', n2: 'n3', n3: 'w' },
    gold: { n1: 'y1', n2: 'y1', n3: 'y2' }
  };

  /* ---------- catalog ---------- */
  function all() {
    const out = [];
    const add = (cat, id, grid, meta) => out.push(Object.assign({ cat, id, grid, w: grid.w, h: grid.h }, meta || {}));

    // terrain
    add('terrain', 'grass_01', grass(1));
    add('terrain', 'grass_02', grass(2));
    add('terrain', 'grass_03', grass(3));
    add('terrain', 'soil_dry', tilled(false));
    add('terrain', 'soil_wet', tilled(true));
    add('terrain', 'dirt_path', dirtPath());
    add('terrain', 'stone_path', stonePath());
    add('terrain', 'wood_floor', woodFloor());
    add('terrain', 'water', water());
    for (const d of ['N', 'E', 'S', 'W', 'NE', 'NW', 'SE', 'SW', 'IN_NE', 'IN_NW', 'IN_SE', 'IN_SW'])
      add('terrain', 'grass_to_dirt_' + d.toLowerCase(), transition(() => grass(1), dirtPath, d), { autotile: 'grass>dirt' });
    for (const d of ['N', 'E', 'S', 'W', 'NE', 'NW', 'SE', 'SW'])
      add('terrain', 'water_edge_' + d.toLowerCase(), transition(water, () => grass(1), d), { autotile: 'water>grass' });
    for (const k of ['post', 'h', 'v', 'post_h', 'corner']) add('terrain', 'fence_' + k, fence(k));

    // crops
    CROPS.forEach(c => STAGES.forEach((s, i) => add('crops', c.id + '_' + i + '_' + s, cropSprite(c, i), { crop: c.name, stage: s, stageIndex: i })));

    // tools
    ['hoe', 'wateringcan', 'axe', 'seedbag', 'shears', 'pickaxe', 'scythe', 'fishingrod'].forEach(t => add('tools', 'tool_' + t, tool(t)));
    Object.entries(TIERS).forEach(([tier, map]) => ['hoe', 'axe', 'pickaxe', 'scythe'].forEach(t =>
      add('tools', `tool_${t}_${tier}`, recolor(tool(t), map), { tier })));

    // character
    const DIRS = ['down', 'left', 'right', 'up'];
    DIRS.forEach(d => {
      [0, 1].forEach(f => add('character', `idle_${d}_${f}`, farmer({ dir: d, pose: 'idle', bob: f }), { anim: 'idle_' + d, frame: f }));
      [0, 1, 2, 3].forEach(f => add('character', `walk_${d}_${f}`, farmer({ dir: d, pose: 'walk', legs: f, bob: f % 2 ? 0 : 1 }), { anim: 'walk_' + d, frame: f }));
      ['windup', 'strike', 'idle'].forEach((p, f) => add('character', `hoe_${d}_${f}`, farmer({ dir: d, pose: p, tool: 'hoe', bob: p === 'strike' ? 1 : 0 }), { anim: 'hoe_' + d, frame: f }));
      ['windup', 'strike', 'idle'].forEach((p, f) => add('character', `axe_${d}_${f}`, farmer({ dir: d, pose: p, tool: 'axe', bob: p === 'strike' ? 1 : 0 }), { anim: 'axe_' + d, frame: f }));
      ['hold', 'water', 'water'].forEach((p, f) => add('character', `water_${d}_${f}`, farmer({ dir: d, pose: p, tool: 'wateringcan', bob: f === 2 ? 1 : 0 }), { anim: 'water_' + d, frame: f }));
      ['harvest_low', 'harvest_low', 'hold'].forEach((p, f) => add('character', `harvest_${d}_${f}`, farmer({ dir: d, pose: p, bob: f === 1 ? 1 : 0 }), { anim: 'harvest_' + d, frame: f }));
      [0, 1].forEach(f => add('character', `fish_${d}_${f}`, farmer({ dir: d, pose: 'hold', tool: 'rod', bob: f }), { anim: 'fish_' + d, frame: f }));
      [0, 1].forEach(f => add('character', `carry_${d}_${f}`, farmer({ dir: d, pose: 'carry', tool: 'crate', legs: f ? 1 : 0, bob: f }), { anim: 'carry_' + d, frame: f }));
      ['windup', 'strike', 'idle'].forEach((p, f) => add('character', `pickaxe_${d}_${f}`, farmer({ dir: d, pose: p, tool: 'pickaxe', bob: p === 'strike' ? 1 : 0 }), { anim: 'pickaxe_' + d, frame: f }));
      ['windup', 'strike', 'idle'].forEach((p, f) => add('character', `scythe_${d}_${f}`, farmer({ dir: d, pose: p === 'windup' ? 'windup' : p, tool: 'scythe', bob: 0, sweep: p === 'strike' }), { anim: 'scythe_' + d, frame: f }));
      [0, 1].forEach(f => add('character', `farmer_cast_${d}_${f}`, farmer({ dir: d, pose: 'cast' + f, tool: 'rod' }), { anim: 'farmer_cast_' + d, frame: f }));
      [0, 1].forEach(f => add('character', `farmer_reel_${d}_${f}`, farmer({ dir: d, pose: 'reel' + f, tool: 'rod', bob: f }), { anim: 'farmer_reel_' + d, frame: f }));
      [0, 1].forEach(f => add('character', `farmer_eat_${d}_${f}`, farmer({ dir: d, pose: 'eat' + f, bob: f }), { anim: 'farmer_eat_' + d, frame: f }));
    });
    add('character', 'farmer_faint', farmerDown('faint'));
    add('character', 'farmer_sleep', farmerDown('sleep'));
    return out;
  }

  function toCanvas(grid, scale, mk) {
    const s = scale || 1;
    const cv = mk ? mk(grid.w * s, grid.h * s) : Object.assign(document.createElement('canvas'), { width: grid.w * s, height: grid.h * s });
    const ctx = cv.getContext('2d');
    ctx.imageSmoothingEnabled = false;
    for (let y = 0; y < grid.h; y++) for (let x = 0; x < grid.w; x++) {
      const key = grid.d[y * grid.w + x];
      const c = PAL[key] || lib.PAL_FX[key];
      if (!c) continue;
      ctx.fillStyle = c; ctx.fillRect(x * s, y * s, s, s);
    }
    return cv;
  }

  const lib = {
    PAL, PAL_FX: {}, all, toCanvas, farmer, farmerDown, cropSprite, tool, CROPS, STAGES, TIERS,
    G, px, rect, disc, outline, flipX, stamp, recolor, hash,
    __grass: grass, __tilled: tilled, __transition: transition, __fence: fence, __water: water, __edgeMask: edgeMask
  };
  if (typeof window !== 'undefined') window.SpriteLib = lib;
  if (typeof globalThis !== 'undefined') globalThis.SpriteLib = lib;
})();
